import React, { useState, useRef, useEffect } from 'react';
import { minerals } from '../minerals.js';

export default function MineralDropdown({ selectedMineral, onMineralSelect, onBackToLanding }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);

  const filteredMinerals = minerals.filter(mineral =>
    mineral.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchQuery('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMineralSelect = (mineralName) => {
    onMineralSelect(mineralName);
    setIsOpen(false);
    setSearchQuery('');
  };

  return (
    <div className="mineral-dropdown" ref={dropdownRef}>
      <div className="mineral-selector" onClick={() => setIsOpen(!isOpen)}>
        <span className="mineral-name">{selectedMineral}</span>
        <svg className="mineral-caret" width="10" height="6" viewBox="0 0 10 6">
          <path fill="#a9a9a9" d="M0 0l5 6 5-6z"/>
        </svg>
      </div>
      
      {isOpen && (
        <div className="mineral-dropdown-panel">
          <div className="mineral-search">
            <input
              type="text"
              placeholder="Search minerals..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>
          <div className="mineral-options">
            
            {filteredMinerals.map(mineral => (
              <div
                key={mineral.name}
                className={`mineral-option ${mineral.name === selectedMineral ? 'selected' : ''}`}
                onClick={() => handleMineralSelect(mineral.name)}
              >
                <span className="mineral-symbol">{mineral.symbol}</span>
                <span className="mineral-details">
                  <span className="mineral-name">{mineral.name}</span>
                  {mineral.atomic_number && (
                    <span className="mineral-number">#{mineral.atomic_number}</span>
                  )}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
